export interface HiddenReleaseSchedulerOpts {
  onRelease: () => void;
  onVisible?: () => void;
  hiddenMs?: number;
  getVisibilityState?: () => DocumentVisibilityState;
}

export interface HiddenReleaseScheduler {
  handleVisibilityChange(): void;
  dispose(): void;
}

export function createHiddenReleaseScheduler(
  opts: HiddenReleaseSchedulerOpts,
): HiddenReleaseScheduler {
  const hiddenMs = opts.hiddenMs ?? 30_000;
  const getVisibilityState =
    opts.getVisibilityState ??
    (() => globalThis.document?.visibilityState ?? 'visible');
  let timer: ReturnType<typeof setTimeout> | null = null;

  function clearPending(): void {
    if (timer === null) return;
    clearTimeout(timer);
    timer = null;
  }

  function handleVisibilityChange(): void {
    if (getVisibilityState() === 'hidden') {
      clearPending();
      timer = setTimeout(() => {
        timer = null;
        if (getVisibilityState() !== 'hidden') return;
        opts.onRelease();
      }, hiddenMs);
      return;
    }

    clearPending();
    opts.onVisible?.();
  }

  return {
    handleVisibilityChange,
    dispose: clearPending,
  };
}
